
import { Component, Vue } from 'vue-property-decorator'
import CardListDetail from '@/components/company/cardList/CardListDetail.vue'

@Component({
  name: 'CardList',
  components: { CardListDetail }
})
class CardList extends Vue {}

export default CardList
